import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface UnshareProjectRoleMutationInput {
  projectId: number;
  roleCode: string;
}

/**
 * Mutation hook for removing a role-scoped share from a project (Owner/Admin only).
 * Calls DELETE /projects/:id/share/role/:roleCode.
 * Invalidates the project detail so share arrays refresh.
 */
export function useUnshareProjectRole() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ projectId, roleCode }: UnshareProjectRoleMutationInput) => {
      await apiClient.delete(`/projects/${projectId}/share/role/${roleCode}`);
    },
    onSuccess: (_data, { projectId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.byId(projectId) });
    },
  });
}
